import React from 'react';
import styled from 'styled-components';
import { ColorNeutralDarkGrey, ColorSpot1, FontWeightNormal, Spacing8 } from 'autogen/design-tokens/tokens';
import Price from './Price';
import type { PriceFontSizes } from './shared/types';

type RecommendedPriceType = {
    recommendedPrice: string;
    size?: PriceFontSizes;
};

const StyledRecommendedPrice = styled(Price)`
    && {
        white-space: nowrap;
        font-weight: ${FontWeightNormal};
        color: ${ColorNeutralDarkGrey};
        line-height: normal;
    }
`;

const Container = styled.span`
    line-height: normal;
`;

export function RecommendedPrice({ recommendedPrice, size = 12, ...restProps }: RecommendedPriceType) {
    return (
        <Container {...restProps}>
            <StyledRecommendedPrice price={recommendedPrice} size={size} />
        </Container>
    );
}
